import { NoddiInfoBanner } from 'noddi-ui-web';
import type { ReactNode } from 'react';
import { CouponCard } from './CouponCard';
import type { CampaignClaimDeadline, CustomerClaimDiscount } from './customerClaimDiscount';

type CouponCardTranslations = {
  used: string;
  activated: string;
  amount: string;
  discount: string;
  free: string;
};

type Props = {
  title: string;
  name?: string;
  description: string;
  imageUrl?: string | null;
  discounts: CustomerClaimDiscount[];
  claimDeadline?: CampaignClaimDeadline | null;
  validAtLabel?: string;
  action?: ReactNode;
  translations?: CouponCardTranslations;
};

export function CampaignCustomerView({
  title,
  name,
  description,
  imageUrl,
  discounts,
  claimDeadline,
  validAtLabel,
  action,
  translations
}: Props) {
  const showName = name != null && name !== '' && name !== title;

  return (
    <div className='flex min-w-0 flex-col gap-4'>
      <div className='flex min-w-0 items-center gap-4'>
        {imageUrl ? <img src={imageUrl} alt='' className='h-16 w-auto max-w-32 shrink-0 object-contain' /> : null}
        <div className='flex min-w-0 flex-col gap-2 text-balance'>
          <h1 className='text-3xl font-bold break-words text-primary md:text-4xl'>{title}</h1>
          {showName && <p className='text-balance break-words'>{name}</p>}
        </div>
      </div>
      {claimDeadline != null && (
        <NoddiInfoBanner
          variant={claimDeadline.isExpired ? 'error' : 'info'}
          size='small'
          icon='Calendar'
          texts={[{ value: claimDeadline.label }]}
        />
      )}
      <p className='text-sm break-words text-muted-foreground'>{description}</p>
      {/* Rendered bare so a bottom-bar action can `order-last` itself below the coupons. */}
      {action}
      {discounts.map((discount) => (
        <CouponCard
          key={discount.id}
          namePublic={discount.namePublic}
          descriptionPublic={discount.descriptionPublic}
          discountAmount={discount.discountAmount}
          currency={discount.currency}
          discountPercentage={discount.discountPercentage}
          validityHint={discount.validityHint}
          validForBrands={discount.validForBrands}
          validAtLabel={validAtLabel}
          translations={translations}
        />
      ))}
    </div>
  );
}
